import PropTypes from 'prop-types'
import React from 'react'
import { ListGroup } from 'react-bootstrap'
import Expense from './Expense'

function ExpenseList(props) {
  const { onDelete, expenses } = props
  return (
    <ListGroup>
      {expenses.map(expense => (
        <Expense key={expense.id} onDelete={onDelete} expense={expense} />
      ))}
    </ListGroup>
  )
}

ExpenseList.propTypes = {
  onDelete: PropTypes.func,
  expenses: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ExpenseList
